import request from '@/utils/request'

/**
 * 保存退货订单
 * @param {Object} data 请求参数
 * @returns {Promise} 返回Promise对象
 */
export function saveInoutOrder(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder/saveInoutOrder',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询订单商品
 * @param {Object} params 请求参数
 * @returns {Promise} 返回Promise对象
 */
export function queryInoutOrderProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder/listInoutOrderProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询订单列表
 * @param {Object} params 请求参数
 * @returns {Promise} 返回Promise对象
 */
export function queryInoutOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inoutOrder/listInoutOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}